/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".checkin__sidebar__item[_ngcontent-%COMP%]{border-radius:3px;overflow:hidden}@media screen and (max-width:1024px){.checkin__sidebar__item[_ngcontent-%COMP%]{box-shadow:none}}@media (max-width:576px){.checkin__sidebar__item[_ngcontent-%COMP%]{overflow:scroll}}.checkin__sidebar__item__subtitle[_ngcontent-%COMP%]{color:#404040;font-size:1.3333333333em;font-weight:600}@media (min-width:577px){.checkin__sidebar__item__subtitle[_ngcontent-%COMP%]{font-size:1em}}"];
export { styles as styles };
